import gql from 'graphql-tag';
const LEFT_RIGHT_PANEL_REVEAL_ACTIVITY_FRAGMENT = gql `
  fragment LeftRightPanelRevealActivityFragment on LeftRightPanelRevealActivity {
    rounds {
      roundIndex
      image
      blocks {
        id
        hasFinished
        numberOfParagraphs
        paragraphs {
          text
          matchingStepIndex
        }
      }
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default LEFT_RIGHT_PANEL_REVEAL_ACTIVITY_FRAGMENT;
